module.exports = __webpack_public_path__ + "img/CUBIC_3.8d85efda.png";